function removeSymbolsInValue(value) {
    const clearedStr = value.replace(/[^\w ]/g, '');
    return clearedStr.replace(' ', '');
}
export function getActiveItem({ searchedValue, suggestionValue, }) {
    const firstPart = removeSymbolsInValue(suggestionValue);
    const secondPart = removeSymbolsInValue(searchedValue);
    return firstPart === secondPart;
}
export function getSuggestionList(data = []) {
    return data.reduce((acc = [], item) => {
        if (!acc) {
            return [item];
        }
        const isValueAlreadyExist = acc.some((j) => getActiveItem({
            suggestionValue: j?.description || '',
            searchedValue: item.description || '',
        }));
        if (isValueAlreadyExist) {
            return [...acc];
        }
        return [...acc, item];
    }, []);
}
export const isStringAndNotEmpty = (value) => typeof value === 'string' && value.trim() !== '';
